import { request } from "apis/base";
import { ChangePasswordRequest, UpdateProfileAvatarRequest, UpdateProfileRequest } from "constants/types/profile";

export const profileApi = {
  getProfile: () => request({ url: "/profile", method: "GET" }),

  update: (data: UpdateProfileRequest) =>
    request({ url: "/profile", method: "PUT", data }),

  changePassword: (data: ChangePasswordRequest) =>
    request({ url: "/profile/change-password", method: "PUT", data }),

  updateAvatar: (data: UpdateProfileAvatarRequest) =>
    request({ url: "/profile", method: "PUT", data }),
};
